import { PAY_ROUTE } from 'constants/routes';
import { usePreserveRecipient } from 'hooks/usePreserveRecipient/usePreserveRecipient';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const RedirectToPay = (props: { cleanSearch?: boolean }) => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const { createUrlWithRecipient } = usePreserveRecipient();

  // biome-ignore lint/correctness/useExhaustiveDependencies: createUrlWithRecipient
  useEffect(() => {
    if (props.cleanSearch) {
      const url = createUrlWithRecipient(PAY_ROUTE, search);
      navigate(url);
    } else {
      navigate(PAY_ROUTE + search);
    }
  }, [navigate, search, props.cleanSearch]);

  return null;
};

export { RedirectToPay };
